import React from "react";
import { getBlog } from "../../api";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

export default function SingleBlog() {
  const { id } = useParams();
  const { data: blog, isFetching } = useQuery({
    queryKey: ["blog"],
    queryFn: () => getBlog(id),
    initialData: [],
  });
  const navigator = useNavigate();

  if (!isFetching && !blog) {
    navigator("/home/not-found");
  }

  return (
    <div className="w-full mb-20">
      <div
        style={{ backgroundImage: `url(${blog.image})` }}
        className="w-full h-[50vh] lg:h-[calc(100vh-110px)] bg-blend-multiply bg-gray-400 bg-no-repeat bg-cover bg-center text-white"
      >
        <div className="text-center flex flex-col justify-center gap-6 lg:gap-10 h-full px-4 lg:px-0">
          <h1 className="text-3xl lg:text-6xl font-bold lg:max-w-[90%] mx-auto">
            {blog.title}
          </h1>
          <p className="text-lg lg:text-2xl lg:w-[70%] mx-auto">
            {blog.summary}
          </p>
          <div className="flex gap-[0.5px]  justify-center">
            <p>
              {new Date(blog.created_at).toLocaleString("en-Us", {
                month: "long",
                year: "numeric",
              })}
            </p>
          </div>
        </div>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: blog.content }}
        className="w-[90%] mx-auto mt-6 mb-20 blogContent"
      ></div>
    </div>
  );
}
